import { combineReducers } from 'redux';
import { StudentState } from './types';
import { coreReducer } from './core/reducer';
import { personalInfoReducer } from './personalInfo/reducer';
import { historyReducer } from './history/reducer';
import { financialsReducer } from './finanacials/reducer';
import { consentsReducer } from './consents/reducer';
import { documentsReducer } from './documents/reducer';
import { financeDocumentsReducer } from './financeDocuments/reducer';
import { preCasInterviewReducer } from './preCasInterview/reducer';
import { enrolmentStatusReducer } from './enrolmentStatus/reducer';
import { visaPrepFormReducer } from './visaPrepForm/reducer';
import { SummaryReducer } from './summary/reducer';
import { messagesReducer } from './messages/reducer';
import { importDataReducer } from './importData/reducer';
import { followUpDocumentsReducer } from './followUpDocuments/reducer';
import { conflictHistoryReducer } from './conflictHistory/reducer';
import { offerReducer } from './offer/reducer';

export const reducer = combineReducers<StudentState>({
  core: coreReducer,
  offer: offerReducer,
  personalInfo: personalInfoReducer,
  history: historyReducer,
  financials: financialsReducer,
  consents: consentsReducer,
  documents: documentsReducer,
  financeDocuments: financeDocumentsReducer,
  followUpDocuments: followUpDocumentsReducer,
  enrolmentStatus: enrolmentStatusReducer,
  preCasInterview: preCasInterviewReducer,
  visa: visaPrepFormReducer,
  summary: SummaryReducer,
  messages: messagesReducer,
  importData: importDataReducer,
  conflictHistory: conflictHistoryReducer
});

export { reducer as studentReducer };
